// The company the UI shows when no `?company=` is present.
//
// This was the literal string 'default' hard-coded in ten files, which was doubly confusing: the
// slug `default` belongs to a specific company (Chentronix), so "default" meant both "the fallback"
// and "that company". The demo is Rassini-only, so the fallback now names Rassini explicitly and
// the two meanings stop overlapping.
//
// Note this is the UI's landing choice, NOT the `default` slug in the database — nothing here renames
// or deletes a company.
export const DEFAULT_COMPANY = 'rassini';

// Companies hidden from the picker. The demo is Rassini-only, and Chentronix (slug `default`) is
// NOT deletable yet: `app.js:697` constructs its engine unconditionally at boot off the file-backed
// machines.json, and `app.js:710` filters `slug !== 'default'` when booting everything else from the
// DB. Deleting the row would leave that engine running against data that no longer exists. Removing
// it for real IS the Phase 2c legacy-shell retirement — until then it is hidden, not gone.
//
// Hiding only affects the picker. `?company=default` still resolves, so nothing that exists becomes
// unreachable — a hidden company you are actively viewing is re-added to the list below so the
// selector can never render blank.
export const HIDDEN_COMPANIES = new Set(['default']);

// A company is pickable if it has a real slug and isn't hidden. The empty-slug row ("Proof
// Manufacturing Co") is a data bug, not a company — it would render an option that selects nothing.
export const pickableCompanies = (companies, currentSlug) =>
  (companies || []).filter(c => c.slug && (!HIDDEN_COMPANIES.has(c.slug) || c.slug === currentSlug));
